<section>
  <app-statistics-sections
    (filterChange)="onFilterChange($event)"
    (statisticsGendersEmitter)="onGetStatisticsGenders($event)"
    (statisticsCardsChartDataEmitter)="onGetChartCardsData($event)"
    (statisticsCardsDataEmitter)="getStatisticsData($event)"
    (commentsEmitter)="onGetComments($event)"
  ></app-statistics-sections>
  <!-- <app-scoreboard-list></app-scoreboard-list> -->
  <!-- <app-map-section ></app-map-section> -->
  <div id="pdf-container">
    <app-pdf-page
      #pdf1
      id="htmlData"
      [statisticsData]="statisticsCardData"
      [filter]="filter"
      [cardsData]="chartCardsData"
      [statisticsGenders]="statisticsGenders"
    ></app-pdf-page>
    <app-pdf-page-two #pdf2 id="htmlData2" [commentsWithRate]="commentsWithRate"></app-pdf-page-two>
    <!-- <app-pdf-page-three #pdf3 id="htmlData3"></app-pdf-page-three> -->
  </div>
</section>
